import React from 'react';
import classNames from 'classnames';
import style from 'assets/jss/material-dashboard-pro-react/views/services/FixedBusinessBroadband/orderStyle';
import { makeStyles } from '@material-ui/core';
import { count } from '../helpers/counter';
import { DisplayM } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import VatClause from 'components/VatClause/VatClause';

// @ts-ignore
const useStyles = makeStyles(style);

interface IOrderProps {
	lines: Array<types.services.fixed.ILine>;
	linesEl: Array<types.services.fixed.IPlansServicesLines>;
	termsAndConditions?: React.ReactElement;
}

const OrderTab = (props: IOrderProps) => {
	const classes = useStyles();
	const summary = count(
		props.lines
			.map((line) => {
				return [
					line.plan?.fee || '0',
					...line.additionalServices.map(({ monthlyFee, oneTimeFee }) => [monthlyFee, oneTimeFee]),
				].flat(3);
			})
			.flat()
	);

	return (
		<div>
			<div>
				{props.linesEl.map((line, ind) => (
					<React.Fragment key={ind}>
						{line.lineEl}
						<div className={classes.planSummaryContainer}>{line.summaryEl}</div>
					</React.Fragment>
				))}
			</div>
			<div className={classes.summaryContainer}>
				<div className={classes.summary}>
					<div className={classNames(classes.flex1, classes.alignCenter)}>
						<DisplayM color="primary-light" disableMargin>
							{translate('summary')}
						</DisplayM>
					</div>
					<div className={classNames(classes.flex1, classes.alignRight)}>
						<DisplayM disableMargin color="primary-light">
							{translate('add.new.line.price', summary)}
						</DisplayM>
					</div>
				</div>
			</div>
			<div className={classes.vat}>
				<VatClause />
			</div>
			<div className={classes.tc}>
				<ConditionalRender show={!!props.termsAndConditions} onTrue={() => props.termsAndConditions} />
			</div>
		</div>
	);
};

export default OrderTab;
